import { Component } from '@angular/core';
import { AppdataService } from '../../service/appdata.service';
import { MatDialog } from '@angular/material/dialog';
import { NewandedittagComponent } from './newandedittag/newandedittag.component';
import { TagService } from '../../service/tag.service';

@Component({
  selector: 'app-tags',
  standalone: false,
  templateUrl: './tags.component.html',
  styleUrl: './tags.component.scss'
})
export class TagsComponent {
  tagGroups: any[] = [];
  tags: any[] = [];
  constructor(
    private appData: AppdataService,
    private dialog: MatDialog,
    private tagService: TagService
  ) {
    this.loadData();
  }

  async loadData() {
    this.tagGroups = await this.appData.tagGroups;
    console.log('TagGroups', this.tagGroups);
    this.tags = await this.appData.tags;
    console.log('Tags', this.tags);
  }

  async reLoadTags() {
    await this.appData.loadAllTags();
    this.tags = await this.appData.tags;
  }

  async editTag(tag: any, group: any) {
    let dia = await this.dialog.open(NewandedittagComponent, {
      data: { tag: tag, group: group },
    });

    dia.afterClosed().subscribe((result) => {
      if (result == true) {
        this.reLoadTags()
      }
    });
  }

  async deleteTag(tag: any) {
    let dia = await this.tagService.deleteTag(tag.id)
    if (dia == true) {
      this.reLoadTags();
    }
  }

  async addTag(group: any) {
    let dia = await this.dialog.open(NewandedittagComponent, {
      data: { group: group },
    });

    dia.afterClosed().subscribe((result) => {
      if (result == true) {
        this.reLoadTags();
      }
    });
  }

}
